import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import HomeLayout from "../../../layouts/home.layout";

export const PermissionDenied: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ type: "spring", stiffness: 260, damping: 20 }}>
        <svg width="132" height="133" viewBox="0 0 132 133" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M66 132.8C102.451 132.8 132 103.251 132 66.8C132 30.3492 102.451 0.800003 66 0.800003C29.5492 0.800003 0 30.3492 0 66.8C0 103.251 29.5492 132.8 66 132.8Z"
            fill="#6F36BC"
            fillOpacity="0.05"
          />
          <path d="M27.36 48.768H105.928V111.88H66.644H40.884H38.308H35.732H27.36V48.768Z" fill="white" />
          <path d="M32.512 105.44V53.92H40.884C53.1504 85.5158 64.8231 94.9881 92.404 100.288V105.44H32.512Z" fill="#6F36BC" fillOpacity="0.1" />
          <path
            d="M41.528 111.88H66.644H98.2C102.468 111.88 105.928 108.42 105.928 104.152V102.22M35.088 111.88V111.88C30.8199 111.88 27.36 108.42 27.36 104.152V56.496C27.36 52.228 30.8199 48.768 35.088 48.768H98.2C102.468 48.768 105.928 52.228 105.928 56.496V75.816"
            stroke="#6F36BC"
            strokeWidth="3.22"
            strokeLinecap="round"
          />
          <path
            d="M71.152 82.8119V93.848C71.152 95.982 69.422 97.712 67.288 97.712V97.712C65.154 97.712 63.424 95.982 63.424 93.848V86.5494V83.7587V82.164M71.152 82.8119V80.968M71.152 82.8119C67.84 83.4597 66.2938 83.4747 63.424 82.164M63.424 80.968V82.164"
            stroke="#6F36BC"
            strokeWidth="3.22"
          />
          <circle cx="67.288" cy="74.528" r="8.694" fill="white" stroke="#6F36BC" strokeWidth="3.22" />
          <path
            d="M94.336 48.768V35.6304C94.336 27.5004 91.4185 19.7033 86.2252 13.9545C81.032 8.20566 73.9884 4.97601 66.644 4.97601C59.2997 4.97601 52.2561 8.20566 47.0628 13.9545C41.8696 19.7033 38.952 27.5004 38.952 35.6304V48.768"
            fill="white"
          />
          <path
            d="M94.336 48.768V35.6304C94.336 27.5004 91.4185 19.7033 86.2252 13.9545C81.032 8.20566 73.9884 4.97601 66.644 4.97601C59.2997 4.97601 52.2561 8.20566 47.0628 13.9545C41.8696 19.7033 38.952 27.5004 38.952 35.6304V48.768H94.336Z"
            stroke="#6F36BC"
            strokeWidth="3.22"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M85.32 48.768V38.3352C85.32 31.879 83.3524 25.6872 79.8499 21.122C76.3475 16.5567 71.5972 13.992 66.644 13.992C61.6908 13.992 56.9405 16.5567 53.4381 21.122C49.9357 25.6872 47.968 31.879 47.968 38.3352V48.768"
            fill="#6F36BC"
            fillOpacity="0.05"
          />
          <path
            d="M85.32 48.768V38.3352C85.32 31.879 83.3524 25.6872 79.8499 21.122C76.3475 16.5567 71.5972 13.992 66.644 13.992C61.6908 13.992 56.9405 16.5567 53.4381 21.122C49.9357 25.6872 47.968 31.879 47.968 38.3352V48.768H85.32Z"
            stroke="#6F36BC"
            strokeWidth="3.22"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M51.3167 16.568C46.3686 21.4599 43.5887 28.0947 43.5887 35.0128V46.192"
            stroke="#6F36BC"
            stroke-opacity="0.05"
            strokeWidth="3.864"
            strokeLinejoin="round"
          />
          <rect x="85.642" y="80.002" width="39.284" height="16.1" rx="3.542" fill="white" stroke="#6F36BC" strokeWidth="3.22" />
          <path
            d="M95.2331 90.9142L95.3209 88.4992L93.2791 89.7945L92.7522 88.8724L94.9038 87.7527L92.7522 86.6331L93.2791 85.711L95.3209 87.0063L95.2331 84.5913H96.2869L96.1991 87.0063L98.2409 85.711L98.7678 86.6331L96.6162 87.7527L98.7678 88.8724L98.2409 89.7945L96.1991 88.4992L96.2869 90.9142H95.2331Z"
            fill="#6F36BC"
          />
          <path
            d="M105.537 90.9142L105.625 88.4992L103.583 89.7945L103.056 88.8724L105.208 87.7527L103.056 86.6331L103.583 85.711L105.625 87.0063L105.537 84.5913H106.591L106.503 87.0063L108.545 85.711L109.072 86.6331L106.92 87.7527L109.072 88.8724L108.545 89.7945L106.503 88.4992L106.591 90.9142H105.537Z"
            fill="#6F36BC"
          />
          <path
            d="M115.841 90.9142L115.929 88.4992L113.887 89.7945L113.36 88.8724L115.512 87.7527L113.36 86.6331L113.887 85.711L115.929 87.0063L115.841 84.5913H116.895L116.807 87.0063L118.849 85.711L119.376 86.6331L117.224 87.7527L119.376 88.8724L118.849 89.7945L116.807 88.4992L116.895 90.9142H115.841Z"
            fill="#6F36BC"
          />
        </svg>
      </motion.div>
      <motion.h1
        className="mt-2 text-xl font-bold text-text-default"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        {`You do not have access to this module.`}
      </motion.h1>
      <motion.div className="mt-6" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.6 }}>
        <Link
          to="/"
          className="px-4 py-2 text-white bg-text-primary rounded  active:bg-brand-dark hover:bg-brand-secondary active:ring active:ring-brand-shade active:ring-offset-1 transition duration-300"
        >
          Go to Home
        </Link>
      </motion.div>
    </div>
  );
};
const PermissionDeniedPage: React.FC = () => {
  return (
    <HomeLayout>
      <PermissionDenied />
    </HomeLayout>
  );
};

export default PermissionDeniedPage;
